import React from 'react';
import { TileProps, TileTypes } from './tiles';
import { Badge } from '../Badge/Badge';
import { MediumTile } from './MediumTile/MediumTile';
import { LargeTile } from './LargeTile/LargeTile';
import { SmallTile } from './SmallTile/SmallTile';
import { TopTenTile } from './TopTenTile/TopTenTile';
import { MicroTile } from './MicroTile/MicroTile';
import { WinnerTile } from './WinnerTile/WinnerTile';
import { AssetTile } from './AssetTile/AssetTile';
import MediumLargeMyOfferTile from './MediumLargeTile/MediumLargeOfferTile';
import { ErrorBoundary } from '@SharedScripts/ErrorBoundary';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import { loadingStatesEmpty } from './LoadingStates';

export interface DynamicTileProps {
  type: Exclude<TileTypes, 'Mega'>;
  data: TileProps;
  className?: string;
  enableLazyLoad?: boolean;
}

export const DynamicTile = (props: DynamicTileProps) => {
  const [isVisible, elementRef] = useIntersectionObserver<HTMLDivElement>({ threshold: 0 });
  const { type, data, className, enableLazyLoad } = props;

  const tileModules = {
    Large: LargeTile,
    Medium: MediumTile,
    Numbered: TopTenTile,
    Small: SmallTile,
    Micro: MicroTile,
    Winner: WinnerTile,
    Asset: AssetTile,
    MediumLargeMyOfferTile: MediumLargeMyOfferTile
  };

  const tileClasses = () => {
    if (type === 'Numbered') return '!top-[4.9rem]';
    if (type === 'Small') return 'cw-badge-tl-10';
    if (type === 'Micro') return 'cw-badge-tl-6';
    return '';
  };

  const badgeSize = () => {
    if (type === 'Small' || type === 'Micro') return 'small';
    return 'large';
  };

  const DynamicTile = tileModules?.[type];

  return (
    <ErrorBoundary>
      <div className={'relative'} ref={elementRef}>
        <>
          {!data.isLoading && data.bannerInfo &&
            <Badge text={data.bannerInfo.text} fontColor={data.bannerInfo.fontColor}
              backgroundColor={data.bannerInfo.backgroundColor} size={badgeSize()} className={tileClasses()}
            />
          }
          {
            enableLazyLoad && !isVisible && loadingStatesEmpty.Medium()
          }
          { (!enableLazyLoad || (enableLazyLoad && isVisible)) &&
            <DynamicTile {...data} className={className}/>
          }
        </>
      </div>
    </ErrorBoundary>
  );
};
